import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import "./AppNavbar.css";
// Replace with your actual logo import path
import Logo from "../../utils/images/LeadsQLogo.png";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Our Services", to: "/courses" },
  { label: "About Us", to: "/about" },
  { label: "Get In Touch", to: "/contact" },
];

export default function AppNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  // Become solid after scrolling 60px
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => setExpanded(false), [location]);

  return (
    <Navbar
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className={`app-navbar ${scrolled ? "app-navbar--scrolled" : ""}`}
      fixed="top"
    >
      <Container className="app-navbar__container">

        {/* ── Logo ── */}
        <Navbar.Brand as={Link} to="/" className="app-navbar__brand">
          <img src={Logo} alt="LeadsQResearch" className="app-navbar__logo" />
          {/* <span className="app-navbar__brand-text">
            Leads<span className="app-navbar__brand-accent">Q</span>Research
          </span> */}
        </Navbar.Brand>

        {/* ── Mobile toggler ── */}
        <Navbar.Toggle
          aria-controls="main-nav"
          className="app-navbar__toggler"
        >
          <span className="app-navbar__toggler-bar" />
          <span className="app-navbar__toggler-bar" />
          <span className="app-navbar__toggler-bar" />
        </Navbar.Toggle>

        {/* ── Nav links ── */}
        <Navbar.Collapse id="main-nav">
          <Nav className="ms-auto app-navbar__nav">
            {navLinks.map((n) => {
              const isActive = location.pathname === n.to;
              return (
                <Nav.Link
                  key={n.to}
                  as={Link}
                  to={n.to}
                  className={`app-navbar__link ${isActive ? "app-navbar__link--active" : ""}`}
                >
                  {n.label}
                  <span className="app-navbar__link-underline" />
                </Nav.Link>
              );
            })}
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
}
